<div [style.backgroundImage]="'url(' + serverPath+item.customField24 + ')'"
    [style.background-color]="item.customField27">

    <div class="container" fxLayout="column" fxLayout.xs="column" fxLayoutGap="30px">



        <div fxFlex>

            <div fxLayout="row" style="height: 100%;margin-top: 3%;">

                <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center">


                    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">

                        <div fxLayout="row">

                            <h2 [style.color]="item.customField28">
                                <calsoft-editor-text [data]="data" [ngStyle.gt-md]="{'font-size': item.customField18 }"
                                    [ngStyle.lt-md]="{
                                    'text-align': item.customField30,
                                    'font-size': item.customField17
                                }" [text]="item.title" [align]="item.customField34">
                                </calsoft-editor-text>
                            </h2>


                            <!-- <h2 [style.color]="item.customField28" [innerHTML]="item.title"></h2> -->

                        </div>

                        <div fxLayout="row">


                            <span [style.color]="item.customField28">

                                <calsoft-editor-text [data]="data" [ngStyle.gt-md]="{'font-size': item.customField37 }"
                                    [ngStyle.lt-md]="{
                                    'text-align': item.customField30,
                                    'font-size': item.customField38
                                }" [text]="item.customField1" [align]="item.customField34">
                                </calsoft-editor-text>
                            </span>


                            <!-- <span [style.color]="item.customField28" class="description"
                                [style.font-size]="item.customField18" [ngStyle.lt-md]="{ 'font-size': item.customField17}"
                                [innerHTML]="item.customField1"></span> -->

                        </div>



                        <div class="margintop">
                            <div fxLayout="row" fxLayout.xs="column" 
                                fxLayoutGap="20px">
                                <button style="color: white;margin-top: 15px;font-weight: bold;padding: 10px 15px;"
                                    [style.border-radius]="item.customField11"
                                    [style.background-color]="item.images[0].customField18" *ngIf="item.categoryId6==0"
                                    (click)="goToCategories(item.customField2)" mat-flat-button
                                    [style.padding-left]="item.images[0].customField20"
                                    [style.padding-right]="item.images[0].customField20"
                                    [style.height]="item.images[0].customField17" [style.font-size]="item.customField25"
                                    [ngStyle.lt-md]="{ 'font-size': item.customField26}"
                                    class="primary">{{item.customField5}}</button>

                                <button style="color: white;margin-top: 15px;font-weight: bold;padding: 10px 15px;"
                                    [style.border-radius]="item.customField11" *ngIf="item.categoryId6==1"
                                    [style.padding-left]="item.images[0].customField20"
                                    [style.padding-right]="item.images[0].customField20"
                                    (click)="link(item.customField2)"
                                    [style.background-color]="item.images[0].customField18" mat-flat-button
                                    class="primary" [style.height]="item.images[0].customField17"
                                    [style.font-size]="item.customField25"
                                    [ngStyle.lt-md]="{ 'font-size': item.customField26}">{{item.customField5}}</button>

                                <button style="color: white;margin-top: 15px ;font-weight: bold;padding: 10px 15px;"
                                    [style.border-radius]="item.customField11" *ngIf="item.categoryId6==0"
                                    [style.height]="item.images[0].customField17"
                                    (click)="openInNewWindow(item.images[0].customField22)" mat-flat-button
                                    [style.background-color]="item.images[0].customField19"
                                    [style.padding-left]="item.images[0].customField20"
                                    [style.padding-right]="item.images[0].customField20"
                                    [style.font-size]="item.customField25"
                                    [ngStyle.lt-md]="{ 'font-size': item.customField26}"
                                    class="primary">{{item.images[0].customField16}}</button>

                                <button style="color: white;margin-top: 15px;font-weight: bold;padding: 10px 15px;"
                                    [style.border-radius]="item.customField11" *ngIf="item.categoryId6==1"
                                    [style.padding-left]="item.images[0].customField20"
                                    [style.padding-right]="item.images[0].customField20"
                                    (click)="openInNewWindow(item.images[0].customField22)"
                                    [style.background-color]="item.images[0].customField19" mat-flat-button
                                    class="primary" [style.height]="item.images[0].customField17"
                                    [style.font-size]="item.customField25"
                                    [ngStyle.lt-md]="{ 'font-size': item.customField26}">{{item.images[0].customField16}}</button>
                            </div>

                        </div>

                    </div>

                </div>
            </div>




        </div>

        <div fxFlex fxLayout="column"
            [ngStyle]="{'margin-top': item.gapBetweenImage, 'margin-bottom': item.gapBetweenImage}"
            fxLayoutAlign="center center" fxLayoutAlign.xs="center center" *ngFor="let img of item.images"
            fxLayoutGap="3%" [style.color]="item.customField28">
            <h3 style="text-align: center;">
                <calsoft-editor-text [data]="data" [ngStyle.gt-md]="{'font-size': item.customField18 }" [ngStyle.lt-md]="{
                'text-align': item.customField30,
                'font-size': item.customField17
            }" [text]="item.customField19" [align]="item.customField34">
                </calsoft-editor-text>
            </h3>
            <img style="width: 100%;" [ngStyle.lt-md]="{'height': item.heightMob}" [style.height]="item.height"
                [src]="serverPath+img.img" [alt]="img.altImage">

        </div>

    </div>

</div>